import React from 'react';

import { configureStore } from '@reduxjs/toolkit'
import { Provider} from 'react-redux';

import {reducers} from './store';

const GestaoProdutosWrapper = (props)=> {
    const {children} = props;
    const {reducer} = reducers;
    const store = configureStore({reducer, preloadedState: {
        filtro: {
            termo: ""
        },
        produtosSelecionados: [],
        listaProdutos: []
    }});
    return <Provider store={store}>
        {children}
    </Provider> 
}

export {GestaoProdutosWrapper}